import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Select } from './Select'

const getHourAndMinutesFromTime = time => {
   let splitTime = time.split(':')

   if (splitTime) {
      return {
         hours: splitTime[0],
         minutes: splitTime[1]
      }
   }
}

const getTimeOptions = (startTime, endTime, durationInMinutes) => {
   const timeOptions = []

   const splitedStartTime = getHourAndMinutesFromTime(startTime)
   const splitedEndTime = getHourAndMinutesFromTime(endTime)

   const startTimeDate = new Date()
   startTimeDate.setHours(splitedStartTime.hours)
   startTimeDate.setMinutes(splitedStartTime.minutes)

   const endTimeDate = new Date()
   endTimeDate.setHours(splitedEndTime.hours)
   endTimeDate.setMinutes(splitedEndTime.minutes)

   let time = startTimeDate
   while (time <= endTimeDate) {
      let hour = ('0' + time.getHours()).slice(-2)
      let minute = ('0' + time.getMinutes()).slice(-2)

      timeOptions.push(hour + ':' + minute)
      time.setMinutes(time.getMinutes() + durationInMinutes) // timestamp
      time = new Date(time) // Date object
   }

   return timeOptions
}

export const TimePicker = ({
   startTime,
   endTime,
   durationInMinutes,
   pickedTime,
   onChange,
   ...props
}) => {
   const timeOptions = getTimeOptions(startTime, endTime, durationInMinutes)
   const [value, setValue] = useState(pickedTime)

   const Options = () =>
      timeOptions.map((option, key) => (
         <option value={option} key={key}>
            {option}
         </option>
      ))

   const onChangeEvent = event => {
      setValue(event.target.value)
      if (typeof onChange === 'function') {
         onChange(event.target.value)
      }
   }

   return (
      <Select maxWidth={'100px'} value={value} onChange={e => onChangeEvent(e)}>
         {Options()}
      </Select>
   )
}

TimePicker.propTypes = {
   /**
    * Start time value, example: '06:00'
    */
   startTime: PropTypes.string.isRequired,
   /**
    * End time value, example: '16:00'
    */
   endTime: PropTypes.string.isRequired,
   /**
    * Choosen default time, example: '08:00'
    */
   pickedTime: PropTypes.string,
   /**
    * Number of minutes between options
    */
   durationInMinutes: PropTypes.number.isRequired,
   /**
    * Extra function on change
    */
   onChange: PropTypes.func
}

TimePicker.defaultProps = {
   startTime: '07:30',
   endTime: '17:30',
   pickedTime: undefined,
   durationInMinutes: 15,
   onChange: undefined
}
